module.exports = __webpack_public_path__ + "img/become_a_patron_button.8b4321f7.png";